import constants from '@/constants'
import {checkSPlitKey } from '@/splitClient';

export default [
  {
    path: "/",
    meta : {requiresAuth : true}
  },
  {
    path: "/authentication",
    name: "authentication",
    meta: { layout: "Auth" },
    component: () =>import("@/views/auth/Authentication.vue"),
  },
  {
    path: "/select-account",
    name: "select-account",
    meta: { layout: "Default",requiresAuth: true },
    component: () =>import("@/views/selectAccount.vue"),
  },
  {
    path: "/password/new",
    name: "Forgot_password",
    meta: { layout: "Auth" },
    component: () => import("./views/auth/ForgotPassword.vue")
  },
  {
    path: "/users/password/edit",
    name: "Reset_password",
    meta: { layout: "Auth" },
    component: () => import("./views/auth/ResetPassword.vue")
  },
  {
    path: "/password/sent",
    name: "Forgot_password_sent",
    meta: { layout: "Auth" },
    component: () => import("./views/auth/ForgotPasswordSuccess.vue")
  },
  {
    path: "/password/reset/success",
    name: "Reset_password_success",
    meta: { layout: "Auth" },
    component: () => import("./views/auth/ResetPasswordSuccess.vue")
  },
  {
    path: "/session/logout",
    name: "Session_logged_out",
    meta: { layout: "Auth" },
    component: () => import("./views/auth/Logout.vue")
  },
  {
    path: "/accounts/:accountId/folders",
    name: "Image_library",
    meta: { requiresAuth: true, folder_type: "image" },
    component: () => import("./views/library/image/ImageLibrary.vue")
  },
  {
    path: "/locked",
    name: "Account_locked",
    meta: { layout: "Auth" },
    component: () => import("./views/auth/Locked.vue")
  },
  {
    path: "/accounts/:accountId/new_user/:token",
    meta: { layout: "Auth", disable_account_check: true },
    component: r => require.ensure([], () => r(require('./views/auth/createProfile')), 'chunks')
  },
  {
    path: "/service/:accountId/dashboard",
    name: "service_dashboard",
    meta: { requiresAuth: true },
    beforeEnter(to, from, next) {
      window.location.href = to.path;
    },
  },
  {
    path: "/accounts/:accountId/account-&-billing/global-unsubscribes",
    name: "Global_unsubscribes",
    meta: { requiresAuth: true },
    component: () => import("./views/self_service/ManageDnmList.vue"),
  },
  {
    path: "/accounts/:accountId/account-&-billing/brand-unsubscribes",
    name: "Brand_unsubscribes",
    meta: { requiresAuth: true },
    component: () => import("./views/self_service/ManageBrandDnmList.vue"),    
  },
  {
    path: "/accounts/:accountId/account-&-billing/sms-unsubscribes",
    name: "SMS_unsubscribes",
    meta: { requiresAuth: true },
    component: () => import("./views/self_service/ManageDnsList.vue"),
  },
  {
    path: "/accounts/:accountId/settings",
    name: "Settings_index",
    meta: { requiresAuth: true },
    component: () => import("./views/settings/SettingsIndex.vue")
  },
  {
    path: "/accounts/:accountId/settings/api-keys",
    name: "Api_keys",
    meta: { requiresAuth: true },
    component: () => import("./views/settings/ApikeysIndex.vue")
  },
  {
    path: "/accounts/:accountId/settings/token",
    name: "Web_token",
    meta: { requiresAuth: true },
    component: () => import("./views/settings/WebToken.vue")
  },
  {
    path: "/accounts/:accountId/settings/conversion-attribute",
    name: "Conversion_attribute",
    meta: { requiresAuth: true },
    component: () => import("./views/settings/ConversionAttribute.vue")
  },
  {
    path: "/accounts/:accountId/settings/relational_table",
    name: "Relational_table",
    meta: { requiresAuth: true },
    component: () => import("./views/settings/RelationalTable.vue")
  },
  {
    path: "/accounts/:accountId/settings/sftp_access",
    name: "Sftp_access",
    meta: { requiresAuth: true },
    component: () => import("./views/settings/SftpAccess.vue")
  },
  {
    path: "/accounts/:accountId/settings/sending-domains",
    name: "Sending_domains",
    meta: { requiresAuth: true },
    component: () => import("./views/settings/SendingDomainsIndex.vue"),
  },
  {
    path: "/accounts/:accountId/settings/sending-domains/first",
    name: "Initial_sending_domain",
    meta: { requiresAuth: true },
    component: () => import("./views/settings/AddNewSendingDomain.vue"),
  },
  {
    path: "/accounts/:accountId/settings/sending-domains/new",
    name: "New_sending_domain",
    meta: { requiresAuth: true },
    component: () => import("./views/settings/AddNewSendingDomain.vue"),
  },
  {
    path: "/accounts/:accountId/settings/sending-domains/:domainId/verify",
    name: "Verify_sending_domain",
    meta: { requiresAuth: true },
    component: () => import("./views/settings/VerifyNewSendingDomain.vue"),
  },
  {
    path: "/accounts/:accountId/settings/link-tracking-domains",
    name: "Link_tracking_domains",
    meta: { requiresAuth: true },
    component: () => import("./views/settings/LinkTracking.vue"),
  },
  {
    path: "/accounts/:accountId/settings/link-tracking-domains/first",
    name: "Initial_link_tracking_domain",
    meta: { requiresAuth: true },
    component: () => import("./views/settings/AddNewLinkTrackingDomain.vue"),
  },
  {
    path: "/accounts/:accountId/settings/link-tracking-domains/new",
    name: "New_link_tracking_domain",
    meta: { requiresAuth: true },
    component: () => import("./views/settings/AddNewLinkTracking.vue"),
  },
  {
    path: "/accounts/:accountId/settings/link-tracking-domains/:domainId/verify",
    name: "Verify_link_tracking_domain",
    meta: { requiresAuth: true },
    component: () => import("./views/settings/VerifyLinkTracking/VerifyNewLinkTracking.vue"),
  },

  {
    path: "/accounts/:accountId/settings/sms-link-tracking-domains",
    name: "SMS_Link_tracking_domains",
    meta: { requiresAuth: true },
    component: () => import("./views/settings/SmsLinkTracking.vue"),
  },
  {
    path: "/accounts/:accountId/settings/sms-link-tracking-domains/new",
    name: "New_link_tracking_domain",
    meta: { requiresAuth: true },
    component: () => import("./views/settings/AddNewSmsLinkTracking.vue"),
  },
  {
    path: "/accounts/:accountId/settings/sms-link-tracking-domains/:domainId/verify",
    name: "Verify_sms_link_tracking_domain",
    meta: { requiresAuth: true, module:'mobile'  },
    component: () => import("./views/settings/VerifyLinkTracking/VerifySmsLinkTracking.vue"),
  },
  {
    path: "/accounts/:accountId/settings/http-post-url",
    name: "Http_post_url",
    meta: { requiresAuth: true },
    component: () => import("./views/settings/HttpPostUrl.vue"),
  },
  {
    path: "/accounts/:accountId/settings/campaign-subject-line",
    name: "Campaign_subject_line",
    meta: { requiresAuth: true },
    component: () => import("./views/settings/SubjectLineCampaign.vue"),
  },
  {
    path: "/accounts/:accountId/settings/sms-compliance-settings",
    name: "Sms_compliance_settings",
    meta: { requiresAuth: true },
    component: () => import("./views/settings/SmsCampaignComplianceSettings.vue"),
  },
  {
    path: "/accounts/:accountId/settings/global-suppression-lists",
    name: "Donot_mail_list",
    meta: { requiresAuth: true },
    component: () => import("./views/settings/DonotMailList.vue"),
  },
  {
    path: "/accounts/:accountId/settings/bulk-delete-contacts",
    name: "Bulk_delete_contacts",
    meta: { requiresAuth: true },
    component: () => import("./views/settings/BulkDeleteContacts.vue"),
  },
  {
    path: "/accounts/:accountId/settings/unique-identifier",
    name: "Unique_identifier",
    meta: { requiresAuth: true },
    component: async() => await checkSPlitKey(constants.SPLIT_IO_KEYS.isUIDAccount) ? import("./views/error/Error404.vue") : import("./views/settings/UniqueIdentifier.vue"),
  },
  {
    path: "/accounts/:accountId/settings/mobile-app-profile",
    name: "Mobile_app_profiles",
    meta: { requiresAuth: true, module:'mobileProfile' },
    component: () => import("./views/settings/MobileAppProfiles/MobileAppIndex.vue"),
  },
  {
    path: "/accounts/:accountId/settings/mobile-app-profile/new",
    name: "New_mobile_app_profile",
    meta: { requiresAuth: true, module:'mobileProfile' },
    component: () => import("./views/settings/mobile_app_profile/NewMobileAppProfile.vue"),
  },
  {
    path: "/accounts/:accountId/settings/mobile-app-profile/:appId",
    name: "Mobile_app_profile_details",
    meta: { requiresAuth: true, module:'mobileProfile' },
    component: () => import("./views/settings/mobile_app_profile/MobileAppProfileDetails.vue"),
  },
  {
    path: "/accounts/:accountId/settings/mobile-app-profile/:appId/edit",
    name: "Edit_mobile_app_profile",
    meta: { requiresAuth: true, module:'mobileProfile' },
    component: () => import("./views/settings/mobile_app_profile/NewMobileAppProfile.vue"),
  },
  {
    path: "/users/edit",
    name: "Edit_user",
    meta: { requiresAuth: true },
    component: () => import("./views/pages/Legacy.vue")
  },
  {
    path: "/error-460",
    name: "No_Access",
    meta: { requiresAuth: true },
    component: () => import("./views/error/Error460.vue")
  },
  {
    path: "/404",
    name: "Error_404",
    meta: {search: false},
    component: () => import("./views/error/Error404.vue")
  },
  {
    path: "/accounts/:accountId/product_roadmap",
    name: "Product_roadmap_error_404",
    meta: { requiresAuth: true },
    component: () => import("./views/error/Error404.vue")
  },
  {
    path: "/accounts/:accountId/mobile",
    name: "Mobile_error_404",
    meta: { requiresAuth: true },
    component: () => import("./views/error/Error404.vue")
  },
  {
    path: "/accounts/:accountId/social",
    name: "Social_error_404",
    meta: { requiresAuth: true },
    component: () => import("./views/error/Error404.vue")
  },
  {
    path: '/accounts/:accountId/integrations',
    name: "Integration_index",
    meta: { requiresAuth: true },
    name: "Integrations_index",
    component: async() => await checkSPlitKey(constants.SPLIT_IO_KEYS.isUIDAccount) ? import("./views/integrations/UIDIntegrationIndex.vue") : import("./views/integrations/IntegrationIndex.vue"),
  }, 
  {
    path: '/accounts/:accountId/integrations/shopify',
    name: 'Shopify_index',
    meta: { requiresAuth: true, module: 'uid'  },
    component: () => import("./views/integrations/shopify/ShopifyIntegrationIndex.vue")
  },
  {
    path: '/accounts/:accountId/integrations/neto',
    name: 'Neto_index',
    meta: { requiresAuth: true, module: 'uid'  },
    component: () => import("./views/integrations/neto/NetoIntegrationIndex.vue")
  },
  {
    path: '/accounts/:accountId/integrations/keap',
    name: 'Keap_cloud_index',
    meta: { requiresAuth: true, module: 'uid' },
    component: () => import("./views/integrations/keap/KeapIntegerationIndex.vue")
  },
  {
    path: '/accounts/:accountId/integrations/zapier',
    name: 'Zapier_index',
    meta: { requiresAuth: true, module: 'uid' },
    component: () => import("./views/integrations/zapier/ZapierIntegerationIndex.vue")
  },
  {
    path: '/accounts/:accountId/integrations/salesforce',
    name: 'Salesforce_index',
    meta: { requiresAuth: true, module: 'uid' },
    component: () => import("./views/integrations/salesforce/SalesforceIntegrationIndex.vue")
  },
  {
    path: '/accounts/:accountId/integrations/clickbank',
    name: 'Clickbank_index',
    meta: { requiresAuth: true, module: 'uid'  },
    component: () => import("./views/integrations/clickbank/ClickBankIntegrationIndex.vue")
  },
  {
    path: '/accounts/:accountId/integrations/carts/:cartType',
    name: 'Cart_index',
    meta: { requiresAuth: true, module: 'uid'  },
    component: () => import("./views/integrations/carts/CartsIntegrationIndex.vue")
  },
  {
    path: '/accounts/:accountId/integrations/retail_express',
    name: 'Retail_express_index',
    meta: { requiresAuth: true, module: 'uid'  },
    component: () => import("./views/integrations/retail_express/RetailExpressIntegrationIndex.vue")
  },
  {
    path: '/accounts/:accountId/integrations/abandoned_cart',
    name: 'Abandoned_cart_index',
    meta: { requiresAuth: true },
    component: () => import("./views/integrations/abandoned_cart/AbandonedCartIndex.vue")
  },
  {
    path: "/commerce",
    name: "Commerce_error_404",
    meta: { requiresAuth: true },
    component: () => import("./views/error/Error404.vue")
  },
  {
    path: "/analytics/mobile",
    name: "Analytics_mobile",
    meta: { requiresAuth: true },
    component: () => import("./views/reports/Mobile.vue")
  },
  {
    path: "/accounts/:accountId/analytics/custom_reports/new",
    name: "Custom_reports_new",
    meta: { requiresAuth: true, chat: false },
    component: () => import("./views/reports/ReportType.vue")
  },
  {
    path: "/accounts/:accountId/analytics/custom_reports",
    name: "Custom_reports",
    meta: { requiresAuth: true },
    component: () => import("./views/reports/CustomReports.vue")
  },
  {
    path: "/accounts/:accountId/analytics/custom_reports/new/campaign",
    name: "Custom_reports_campaign",
    meta: { requiresAuth: true },
    component: () => import("./views/reports/campaign/Stepper.vue")
  },
  {
    path:
      "/accounts/:accountId/analytics/custom_reports/campaign/:reportId/duplicate",
    name: "Custom_reports_campaign_duplicate",
    meta: { requiresAuth: true },
    component: () => import("./views/reports/campaign/Stepper.vue")
  },
  {
    path:
      "/accounts/:accountId/analytics/custom_reports/campaign/:reportId/edit",
    name: "Custom_reports_campaign_edit",
    meta: { requiresAuth: true },
    component: () => import("./views/reports/campaign/Stepper.vue")
  },
  {
    path: "/accounts/:accountId/analytics/custom_reports/new/sms",
    name: "Custom_reports_sms",
    meta: { requiresAuth: true },
    component: () => import("./views/reports/sms/Stepper.vue")
  },
  {
    path: "/accounts/:accountId/analytics/custom_reports/new/message",
    name: "Custom_reports_message",
    meta: { requiresAuth: true },
    component: () => import("./views/reports/message/Stepper.vue")
  },
  {
    path:"/accounts/:accountId/analytics/custom_reports/sms_message_report/:reportId/duplicate",
    name: "Custom_reports_message_duplicate",
    meta: { requiresAuth: true },
    component: () => import("./views/reports/message/Stepper.vue")
  },
  {
    path:
      "/accounts/:accountId/analytics/custom_reports/sms_message_report/:reportId/edit",
    name: "Custom_reports_edit",
    meta: { requiresAuth: true },
    component: () => import("./views/reports/message/Stepper.vue")
  },
  {
    path:
      "/accounts/:accountId/analytics/custom_reports/sms_report/:reportId/duplicate",
    name: "Custom_reports_duplicate",
    meta: { requiresAuth: true },
    component: () => import("./views/reports/sms/Stepper.vue")
  },
  {
    path:
      "/accounts/:accountId/analytics/custom_reports/sms_report/:reportId/edit",
    name: "Custom_reports_edit",
    meta: { requiresAuth: true },
    component: () => import("./views/reports/sms/Stepper.vue")
  },
  {
    path: "/accounts/:accountId/analytics/custom_reports/new/growth_attrition",
    name: "Custom_reports_new_growth",
    meta: { requiresAuth: true },
    component: () => import("./views/reports/growthAttrition/Stepper.vue")
  },
  {
    path:
      "/accounts/:accountId/analytics/custom_reports/growth_attrition/:reportId/edit",
    name: "Custom_reports_growth_edit",
    meta: { requiresAuth: true },
    component: () => import("./views/reports/growthAttrition/Stepper.vue")
  },
  {
    path:
      "/accounts/:accountId/analytics/custom_reports/growth_attrition/:reportId/duplicate",
    name: "Custom_reports_growth_duplicate",
    meta: { requiresAuth: true },
    component: () => import("./views/reports/growthAttrition/Stepper.vue")
  },
  {
    path: "/accounts/:accountId/analytics/custom_reports/new/deliverability",
    name: "Custom_reports_deliverability",
    meta: { requiresAuth: true },
    component: () => import("./views/reports/deliverability/Stepper.vue")
  },
  {
    path:
      "/accounts/:accountId/analytics/custom_reports/deliverability/:reportId/duplicate",
    name: "Custom_reports_deliverability_duplicate",
    meta: { requiresAuth: true },
    component: () => import("./views/reports/deliverability/Stepper.vue")
  },
  {
    path:
      "/accounts/:accountId/analytics/custom_reports/deliverability/:reportId/edit",
    name: "Custom_reports_deliverability_edit",
    meta: { requiresAuth: true },
    component: () => import("./views/reports/deliverability/Stepper.vue")
  },
  {
    path: "/accounts/:accountId/analytics/custom_reports/:reportId/campaign",
    name: "Custom_reports_campaign",
    meta: { requiresAuth: true },
    component: () => import("./views/reports/Dashboard.vue")
  },
  {
    path: "/accounts/:accountId/dashboard",
    name: "Dashboard",
    meta: { requiresAuth: true, layout: "Dashboard", search: {path:"/campaigns"} },
    component: r => import('./views/Dashboard')
  },
  {
    path: "/accounts/:accountId/reports/recurring_campaign_report",
    name: "Recurring_campaign_report",
    meta: { requiresAuth: true },
    component: () => import("./views/reports/RecurringReports.vue")
  },
  {
    path: "/accounts/:accountId/reports/test_reports",
    name: "Test_campaign_reports",
    meta: { requiresAuth: true },
    component: () => import("./views/reports/TestReports.vue")
  },
  {
    path: "/accounts/:accountId/website_reports",
    name: "Website_reports",
    meta: { requiresAuth: true },
    component: () => import("./views/reports/Website.vue")
  },
  {
    path: "/accounts/:accountId/reports/journeys",
    name: "Journey_reports",
    meta: { requiresAuth: true },
    component: () => import("./views/reports/Journey.vue")
  },
  {
    path: "/accounts/:accountId/pivot_reports",
    name: "Pivot_reports",
    meta: { requiresAuth: true },
    component: () => import("./views/error/Error404.vue")
  },
  {
    path: "/accounts/:accountId/transactional_campaigns/reports",
    name: "Transactional_campaign_reports",
    meta: { requiresAuth: true },
    component: () => import("./views/reports/TransactionalReports.vue")
  },
  {
    path: "/accounts/:accountId/erfm_report",
    name: "erfm_report",
    meta: { requiresAuth: true },
    component: () => import("./views/reports/erfmReport/ERFMReport.vue")
  },
  {
    path: "/accounts/:accountId/get_logs",
    name: "Get_logs",
    meta: { requiresAuth: true },
    component: () => import("./views/pages/Legacy.vue")
  },
  {
    path: "/accounts/:accountId/social_schedules/queue",
    name: "Social_schedules_queue",
    meta: { requiresAuth: true, search: {path: '/campaigns'} },
    component: () => import("./views/pages/Legacy.vue")
  },
  {
    path: "/accounts/:accountId/brands",
    name: "Brand_management",
    meta: { requiresAuth: true, section:'brand_management' },
    component: () => import("./views/brands/Brand.vue")
  },
  {
    path: "/accounts/:accountId/secure_lists",
    name: "Secure_lists",
    meta: { requiresAuth: true },
    component: () => import("./views/lists/secure/SecureLists.vue")
  },
  {
    path: "/accounts/:accountId/sms_lists",
    component: async() => await checkSPlitKey(constants.SPLIT_IO_KEYS.isUIDAccount) ? import("./views/error/Error404.vue") : import("./views/sms_contact/SmsLists.vue"),
    name: "SMS_contact_lists",
    meta: { requiresAuth: true, section:'sms_lists' },
  },
  {
    path: "/accounts/:accountId/sms_lists/:listId",
    name: "SMS_contact_list_dashboard",
    component: async() => await checkSPlitKey(constants.SPLIT_IO_KEYS.isUIDAccount) ? import("./views/error/Error404.vue") : import("./views/sms_contact/SmsListDashboard.vue"),
    meta: { requiresAuth: true, section:'sms_lists' }
  },
  {
    path: "/accounts/:accountId/sms_lists/:listId/sms_contacts",
    name: "SMS_contacts",
    component: async() => await checkSPlitKey(constants.SPLIT_IO_KEYS.isUIDAccount) ? import("./views/error/Error404.vue") : import("./views/sms_contact/SmsContacts.vue"),
    meta: { requiresAuth: true, section:'sms_lists' },
  },
{
    path: '/accounts/:accountId/sms_lists/:list_id/sms_contact_import',    
    name: "SMS_contact_import",   
    meta: { requiresAuth: true, section:'sms_lists' },
    component: async() => await checkSPlitKey(constants.SPLIT_IO_KEYS.isUIDAccount) ? import("./views/error/Error404.vue") : import("./views/sms_contact/ContactImport.vue")
},
{
  path: "/accounts/:accountId/sms_lists/:listId/sms_contacts/:contactId",
  name: "SMS_contact_detail",
  component : async() => await checkSPlitKey(constants.SPLIT_IO_KEYS.isUIDAccount) ? import("./views/error/Error404.vue") : import("./views/sms_contact/contact/SmsContact.vue"),
  meta: { requiresAuth: true, section:'sms_lists' }
},
{
  path: "/accounts/:accountId/sms_contacts/:contactId",
  component: async() => await checkSPlitKey(constants.SPLIT_IO_KEYS.isUIDAccount) ? import("./views/error/Error404.vue") : import("./views/sms_contact/contact/SmsContact.vue"),
  meta: { requiresAuth: true, section:'sms_lists' }
},
  {
    path: "/accounts/:accountId/campaigns",
    name: "Email_campaigns",
    meta: { requiresAuth: true, folder_type: "campaign" },
    component: () => import("./views/campaigns/email/EmailCampaigns.vue")
  },
  {
    path: "/accounts/:accountId/campaigns/new",
    name: "Campaigns_new",
    meta: { requiresAuth: true, childRouteWithinFolder: "campaign", implementTimezone: true },
    component: () => import("./views/campaigns/email/new/NewCampaign.vue")
  },
  {
    path: "/accounts/:accountId/campaigns/new/email",
    name: "Campaigns_new_email",
    meta: {
      requiresAuth: true,
      campaignType: 1,
      childRouteWithinFolder: "campaign",
      restrictIframe:true,
      implementTimezone: true
    },
    component: () => import("./views/campaigns/email/new/Init.vue")
  },
  {
    path: "/accounts/:accountId/campaigns/:campaignId/edit",
    name: "Campaigns_edit",
    meta: { requiresAuth: true, childRouteWithinFolder: "campaign" ,restrictIframe:true, implementTimezone: true},
    component: () => import("./views/campaigns/email/new/Init.vue")
  },
  {
    path: "/accounts/:accountId/campaigns/:campaignId/duplicate",
    name: "Campaigns_duplicate",
    meta: { requiresAuth: true, childRouteWithinFolder: "campaign",restrictIframe:true, implementTimezone: true },
    component: () => import("./views/campaigns/email/new/Init.vue")
  },
  {
    path: "/accounts/:accountId/campaigns/new_ab_test",
    name: "create_ab_Campaigns",
    meta: {
      requiresAuth: true,
      campaignType: 3,
      childRouteWithinFolder: "campaign",
      implementTimezone: true
    },
    component: () => import("./views/campaigns/email/ab_report/Init.vue")
  },
  {
    path: "/accounts/:accountId/campaigns/:campaignId/ab_duplicate",
    name: "ab_Campaigns_new_email_duplicate",
    meta: {
      requiresAuth: true,
      campaignType: 3,
      childRouteWithinFolder: "campaign",
      implementTimezone: true
    },
    component: () => import("./views/campaigns/email/ab_report/Init.vue")
  },
  {
    path: "/accounts/:accountId/campaigns/:campaignId",
    name: 'campaign dashboard',
    meta: { requiresAuth: true ,  removedPlatform: [] },
    component: () => import("./views/campaigns/email/dashboard/email/Init.vue"),
    props: true,
    children: [
      {
        path: "",
        name: "campaign dashboard main",
        meta: { requiresAuth: true, routeName:'dashboard' },
        component: () => import("./views/campaigns/email/dashboard/email/Dashboard.vue"),        
      },
      {
        path: "overlay",
        name: "campaign dashboard overlay",
        meta: { requiresAuth: true, routeName:'overlay' },
        component: () => import("./views/campaigns/email/dashboard/email/Overlay.vue"),        
      },
      {
        path: "isp",
        name: "campaign dashboard Isp",
        meta: { requiresAuth: true, routeName:'isp' },
        component: () => import("./views/campaigns/email/dashboard/email/Isp.vue"),        
      },
      {
        path: "details",
        name: "campaign dashboard details",
        meta: { requiresAuth: true, routeName:'details' },
        component: () => import("./views/campaigns/email/dashboard/email/Details.vue"),        
      },
    ],
  },
  {
    path: "/accounts/:accountId/campaigns/content/:contentId",
    name: "Campaigns_content",
    meta: { requiresAuth: true, folder_type: "campaign",campaignType: 1, childRouteWithinFolder: "campaign", implementTimezone: true },
    component: () => import("./views/campaigns/email/new/Init.vue")
  },
  {
    path: "/accounts/:accountId/segments",
    name: "Segments",
    meta: { requiresAuth: true, folder_type: "segment" },
    component : async () => await checkSPlitKey(constants.SPLIT_IO_KEYS.isUIDAccount) ? import("./views/segments/UIDSegments.vue") : import("./views/segments/Segments.vue")
  },
  {
    path: "/accounts/:accountId/segments/types",
    name: "Segments_types",
    meta: { requiresAuth: true, childRouteWithinFolder: "segment" },
    component: () => import("./views/segments/SegmentsTypes.vue")
  },
  {
    path: "/accounts/:accountId/segments/new",
    name: "Segments_new",
    meta: { requiresAuth: true, childRouteWithinFolder: "segment" },
    component: () => import("./views/pages/Legacy.vue")
  },
  {
    path: "/accounts/:accountId/segments/next-gen",
    name: "Next_gen_segments",
    meta: { requiresAuth: true, childRouteWithinFolder: "segment" },
    component: () => import("./views/segments/nextGen/Init.vue")
  },
  {
    path: "/accounts/:accountId/segments/next-gen/:segmentId/edit",
    name: "Next_gen_segments_edit",
    meta: { requiresAuth: true, childRouteWithinFolder: "segment" },
    component: () => import("./views/segments/nextGen/Init.vue")
  },
  {
    path: "/accounts/:accountId/segments/next-gen/:segmentId/duplicate",
    name: "Next_gen_segments_duplicate",
    meta: { requiresAuth: true, childRouteWithinFolder: "segment" },
    component: () => import("./views/segments/nextGen/Init.vue")
  },
  {
    path: "/accounts/:accountId/segments/:segmentId",
    name: "View_segment",
    meta: { requiresAuth: true, childRouteWithinFolder: "segment" },
    component: () => import("./views/segments/SegmentDetails.vue")
  },
  {
    path: "/accounts/:accountId/segments/:segmentId/duplicate",
    name: "Duplicate_segment",
    meta: { requiresAuth: true, childRouteWithinFolder: "segment" },
    component: () => import("./views/pages/Legacy.vue")
  },
  {
    path: "/accounts/:accountId/segments/:segmentId/edit",
    name: "Edit_segment",
    meta: { requiresAuth: true, childRouteWithinFolder: "segment" },
    component: () => import("./views/pages/Legacy.vue")
  },
  {
    path: "/accounts/:accountId/contents",
    name: "Contents",
    meta: { requiresAuth: true, folder_type: "content" },
    component: () => import("./views/content/email/EmailContent.vue")
  },
  {
    path: "/accounts/:accountId/contents/template/:templateId/preview",
    name: "Content_template_preview",
    meta: { requiresAuth: true, layout: "Default" },
    component: () => import("./views/content/email/templates/Preview.vue")
  },
  {
    path: "/accounts/:accountId/contents/select",
    name: "Email_content_select_editor",
    meta: { requiresAuth: true },
    component: () => import("./views/content/email/CreateFromScratch.vue")
  },
  {
    path: "/accounts/:accountId/contents/layouts",
    name: "Email_content_dnd_layout",
    meta: {
      requiresAuth: true,
      childRouteWithinFolder: "content",
      skipConfirmationPopup: true,
    },
    component: () => import("./views/content/email/DnDLayouts.vue")
  },
  {
    path: "/accounts/:accountId/contents/new",
    name: "Email_content_new",
    meta: {
      requiresAuth: true,
      childRouteWithinFolder: "content",
      skipConfirmationPopup: true,
    },
    component: () => import("./views/pages/Legacy.vue")
  },
  {
    path: "/accounts/:accountId/contents/drag_and_drop_beta",
    name: "Email_content_dnd",
    meta: {
      requiresAuth: true,
      childRouteWithinFolder: "content",
      skipConfirmationPopup: true
    },
    component: () => import("./views/content/email/editors/EditorContentInit.vue")
  },
  {
    path: "/accounts/:accountId/contents/wysiwyg",
    name: "Email_content_wysiwyg",
    meta: {
      requiresAuth: true,
      childRouteWithinFolder: "content",
      skipConfirmationPopup: true,
    },
    component: () => import("./views/content/email/editors/EditorContentInit.vue")
  },
  {
    path: "/accounts/:accountId/contents/wysiwyg/:contentId",
    name: "Email_content_wysiwyg_edit",
    meta: { requiresAuth: true,childRouteWithinFolder: "content"},
    component: () => import("./views/content/email/editors/EditorContentInit.vue")
  },
  {
    path: "/accounts/:accountId/contents/pull_from_url",
    name: "Email_content_pullfromurl",
    meta: {
      requiresAuth: true,
      childRouteWithinFolder: "content",
      skipConfirmationPopup: true,
    },
    component: () => import("./views/content/email/editors/EditorContentInit.vue")
  },
  {
    path: "/accounts/:accountId/contents/pull_from_url/:contentId",
    name: "Email_content_pullfromurl_edit",
    meta: { requiresAuth: true,childRouteWithinFolder: "content"},
    component: () => import("./views/content/email/editors/EditorContentInit.vue")
  },
  {
    path: "/accounts/:accountId/contents/html_editor",
    name: "Email_content_html",
    meta: {
      requiresAuth: true,
      childRouteWithinFolder: "content",
      skipConfirmationPopup: true,
    },
    component: () => import("./views/content/email/editors/EditorContentInit.vue")
  },
  {
    path: "/accounts/:accountId/contents/html_editor/:contentId",
    name: "Edit_html_editor_content",
    meta: { requiresAuth: true, childRouteWithinFolder: "content", dragDropRoute:true },
    component: () => import("./views/content/email/editors/EditorContentInit.vue")
  },
  {
    path: "/accounts/:accountId/contents/template",
    name: "Content_templates",
    meta: { requiresAuth: true, folder_type: "content_template" },
    component: () => import("./views/content/email/TemplateView.vue")
  },
  {
    path: "/accounts/:accountId/contents/:contentId",
    name: "Email_content_dashboard",
    meta: {
      requiresAuth: true,
      childRouteWithinFolder: "content",
      skipConfirmationPopup: true,
    },
    component: () => import("./views/content/email/dashboard/Init.vue"),
  },
  {
    path: "/accounts/:accountId/contents/:contentId/preview",
    name: "Email_content_preview",
    meta: {
      requiresAuth: true,
      childRouteWithinFolder: "content",
      skipConfirmationPopup: true,
    },
    redirect: {name :"Email_content_dashboard"}
  },
  {
    path: "/accounts/:accountId/contents/:contentId",
    name: "View_contents",
    meta: { requiresAuth: true,childRouteWithinFolder: "content", skipConfirmationPopup:true },
    component: () => import("./views/pages/Legacy.vue")
  },
  {
    path: "/accounts/:accountId/contents/:contentId/edit",
    name: "Edit_contents",
    meta: { requiresAuth: true,childRouteWithinFolder: "content"},
    component: () => import("./views/pages/Legacy.vue")
  },
  {
    path: "/accounts/:accountId/contents/:contentId/render_preview",
    name: "Email_contents_render_preview",
    meta: { requiresAuth: true, childRouteWithinFolder: "content"},
    component: () => import("./views/content/email/render_preview/Init.vue"),
  },
  {
    path: "/accounts/:accountId/contents/drag_and_drop_beta/:contentId",
    name: "Edit_drag_and_drop_content",
    meta: { requiresAuth: true, childRouteWithinFolder: "content", dragDropRoute:true },
    component: () => import("./views/content/email/editors/EditorContentInit.vue")
  },
  {
    path: "/accounts/:accountId/lists",
    name: "Contact_lists",
    meta: { requiresAuth: true, folder_type: "list" },
    component: async () => await checkSPlitKey(constants.SPLIT_IO_KEYS.isUIDAccount) ? import("./views/lists/lists/UIDLists.vue") : import("./views/lists/lists/Lists.vue")
  },
  {
    path: "/accounts/:accountId/create_list",
    name: "Create_list",
    meta: { requiresAuth: true, childRouteWithinFolder: "list" },
    component: async() => await checkSPlitKey(constants.SPLIT_IO_KEYS.isUIDAccount) ? import("./views/lists/lists/UIDCreateList.vue") : import("./views/lists/lists/CreateList.vue")
  },
  {
    path: "/accounts/:accountId/lists/:listId/edit",
    name: "List_edit",
    meta: { requiresAuth: true, childRouteWithinFolder: "list" },
    component: async() => await checkSPlitKey(constants.SPLIT_IO_KEYS.isUIDAccount) ? import("./views/lists/lists/UIDCreateList.vue") : import("./views/lists/lists/CreateList.vue")
  },
  {
    path: "/accounts/:accountId/lists/:listId/duplicate",
    name: "List_duplicate",
    meta: { requiresAuth: true, childRouteWithinFolder: "list" },
    component: async() => await checkSPlitKey(constants.SPLIT_IO_KEYS.isUIDAccount) ? import("./views/lists/lists/UIDCreateList.vue") : import("./views/lists/lists/CreateList.vue")
  },
  {
    path:"/accounts/:accountId/contacts",
    name:"All_contacts",
    meta:{ requiresAuth: true},
    component: async() => await checkSPlitKey(constants.SPLIT_IO_KEYS.isUIDAccount) ? import("./views/contacts/AllContacts.vue") : import("./views/error/Error404.vue")
  },
  {
    path:"/accounts/:accountId/contact/new",
    name:"New_contacts",
    meta:{ requiresAuth: true},
    component: async() => await checkSPlitKey(constants.SPLIT_IO_KEYS.isUIDAccount) ? import("./views/contacts/UIDCreateContact.vue") : import("./views/contacts/CreateContact.vue")
  },
  {
    path: "/accounts/:accountId/lists/:listId/contacts",
    name: "List_contacts",
    meta: { requiresAuth: true, childRouteWithinFolder: "list" },
    component: async() => await checkSPlitKey(constants.SPLIT_IO_KEYS.isUIDAccount) ? import("./views/contacts/UIDContacts.vue") : import("./views/contacts/Contacts.vue")
  },
  {
    path: "/accounts/:accountId/lists/:listId/create_contact",
    name: "List_create_contact",
    meta: { requiresAuth: true },
    component: async () => await checkSPlitKey(constants.SPLIT_IO_KEYS.isUIDAccount) ? import("./views/contacts/UIDCreateContact.vue") : import("./views/contacts/CreateContact.vue")
  },
  {
    path: "/accounts/:accountId/lists/:listId",
    name: "List_view",
    meta: { requiresAuth: true, childRouteWithinFolder: "list" },
    component: async () => await checkSPlitKey(constants.SPLIT_IO_KEYS.isUIDAccount) ? import("./views/lists/lists/UIDListDashboard.vue") : import("./views/lists/lists/ListDashboard.vue"),
    props: true,
  },
  {
    path: "/accounts/:accountId/lists/:list_id/ftp_import",
    name: "List_ftp_import",
    meta: { requiresAuth: true },
    component: async () => await checkSPlitKey(constants.SPLIT_IO_KEYS.isUIDAccount) ? import("./views/lists/lists/UIDFtpImport.vue") : import("./views/lists/lists/FtpImport.vue")
  },
  {
    path: "/accounts/:accountId/lists/:list_id/automated_import",
    name: "List_automated_import",
    meta: { requiresAuth: true },
    component: async () => await checkSPlitKey(constants.SPLIT_IO_KEYS.isUIDAccount) ? import("./views/lists/lists/UIDAutomatedImport.vue") : import("./views/lists/lists/AutomatedImport.vue")
  },
  {
    path: "/accounts/:accountId/lists/:list_id/file_import",
    name: "File_import",
    meta: { requiresAuth: true },
    component: async () => await checkSPlitKey(constants.SPLIT_IO_KEYS.isUIDAccount) ? import("./views/lists/lists/UIDFileImport.vue") : import("./views/lists/lists/FileImport.vue")
  },
  {
    path: "/accounts/:accountId/content_templates/new",
    name: "New_content_templates",
    meta: { requiresAuth: true, childRouteWithinFolder: "content_template" },
    component: () => import("./views/content/email/templates/TemplateWrapper.vue")
  },
  {
    path: "/accounts/:accountId/content_templates/select_editor",
    name: "Select_content_templates_editor",
    meta: { requiresAuth: true,childRouteWithinFolder: "content_template", },
    component: () => import("./views/content/email/templates/TemplateEditorSelection.vue")
  },
  {
    path: "/accounts/:accountId/content_templates/layouts",
    name: "Content_template_dnd_layout",
    meta: {
      requiresAuth: true,
      childRouteWithinFolder: "content_template",
      skipConfirmationPopup: true,
    },
    component: () => import("./views/content/email/DnDLayouts.vue")
  },
  {
    path: "/accounts/:accountId/content_templates/edit_template/:id",
    name: 'Edit_content_template_legacy',
    redirect: "/404"
  },
  {
    path: "/accounts/:accountId/content_templates/:templateId/edit",
    name: "Edit_content_templates",
    meta: { requiresAuth: true, childRouteWithinFolder: "content_template" },
    component: () => import("./views/content/email/templates/TemplateWrapper.vue")
  },
  {
    path: "/accounts/:accountId/content_templates/choose_template",
    name: "Choose_template",
    meta: { requiresAuth: true, childRouteWithinFolder: "content_template", },
    redirect:  to  => ({ name: 'Content_templates', query: { activeTab: 'mytemplate' } }),
  },
  {
    path: "/accounts/:accountId/content_templates/drag_and_drop_beta/:templateId",
    name: "dnd_content_templates_edit",
    meta: { requiresAuth: true,childRouteWithinFolder: "content_template" },
    component: () => import("./views/content/email/templates/TemplateWrapper.vue")
  },
  {
    path: "/accounts/:accountId/content_templates/drag_and_drop_beta",
    name: "New_dnd_content_template",
    meta: { requiresAuth: true, childRouteWithinFolder: "content_template", },
    component: () => import("./views/content/email/templates/TemplateWrapper.vue")
  },
  {
    path: "/accounts/:accountId/content_templates",
    name: "Legacy_content_templates",
    meta: { requiresAuth: true, childRouteWithinFolder: "content_template", },
    redirect:  to  => ({ name: 'Content_templates', query: { activeTab: 'mytemplate' } }),
  },
  {
    path: "/accounts/:accountId/notifications",
    name: "Notifications",
    meta: { requiresAuth: true },
    component: () => import("./views/pages/Notifications.vue")
  },
  {
    path: "/accounts/:accountId/process-queue",
    name: "Process_Queue",
    meta: { requiresAuth: true },
    component: () => import("./views/pages/ProcessQueue.vue")
  },
  {
    path: "/roadmap",
    name: "Roadmap",
    meta: { requiresAuth: true, chat: false },
    component: () => import("./views/Roadmap.vue")
  },
  {
    path: "/accounts/:accountId/acquisition/forms",
    name: "Acquisition_forms",
    meta: { requiresAuth: true, chat: false, folder_type: 'acquisition_form', section:'acquisition_builder' },
    component: () => import("./views/acquisition/builder/AcquisitionBuilder.vue")
  },
  {
    path: '/accounts/:accountId/acquisition/forms/select',
    name: "Acquisition_forms_selection",
    meta: { requiresAuth: true, childRouteWithinFolder: 'acquisition/form' },
    component: () => import('./views/acquisition/forms/new/FormSelection.vue'),
  },
  {
    path: '/accounts/:accountId/acquisition/forms/create',
    name: "Acquisition_forms_create",
    meta: { requiresAuth: true, childRouteWithinFolder: 'acquisition/form' },
    component: () => import('./views/acquisition/forms/new/Init.vue'),
  },
  {
    path: '/accounts/:accountId/acquisition/forms/:formId/modify',
    name: "Acquisition_forms_edit",
    meta: { requiresAuth: true, childRouteWithinFolder: 'acquisition/form' },
    component: () => import('./views/acquisition/forms/new/Init.vue'),
  },
  {
    path: '/accounts/:accountId/acquisition/forms/:formId/preview',
    name: "Acquisition_forms_preview",
    meta: { requiresAuth: true, childRouteWithinFolder: 'acquisition/form' },
    component: () => import('./views/acquisition/forms/new/FormPreview.vue'),
  },
  {
    path: '/accounts/:accountId/landing_pages/create',
    name: "New_landing_pages",
    meta: { requiresAuth: true, childRouteWithinFolder: 'landing_page', resetSnackbar: true},
    component: () => import("./views/acquisition/landing_pages/new/BuilderSelection.vue"),
  },
  {
    path: '/accounts/:accountId/landing_pages/template',
    name: "Landing_pages_template",
    meta: { requiresAuth: true, childRouteWithinFolder: 'landing_page', resetSnackbar: true},
    component: () => import("./views/acquisition/landing_pages/new/Template.vue"),
  },
  {
    path: '/accounts/:accountId/landing_pages/details',
    name: "Landing_page_Details",
    meta: { requiresAuth: true, childRouteWithinFolder: 'landing_page', resetSnackbar: true},
    component: () => import("./views/acquisition/landing_pages/new/LandingPageDetails.vue"),
  },
  {
    path: '/accounts/:accountId/landing_pages/duplicate',
    name: "Duplicate_landing_page",
    meta: { requiresAuth: true, childRouteWithinFolder: 'landing_page', resetSnackbar: true},
    component: () => import("./views/acquisition/landing_pages/new/LandingPageDetails.vue"),
  },
  {
    path: '/accounts/:accountId/landing_pages/wysiwyg_editor',
    name: "Landing_page_wysiwyg",
    meta: { requiresAuth: true, childRouteWithinFolder: 'landing_page', resetSnackbar: true, implementTimezone: true},
    component: () => import("./views/acquisition/landing_pages/new/Wysiwyg.vue"),
  },
  {
    path: '/accounts/:accountId/landing_pages/wysiwyg_editor/:pageId/edit',
    name: "Landing_page_wysiwyg_edit",
    meta: { requiresAuth: true, childRouteWithinFolder: 'landing_page', resetSnackbar: true, implementTimezone: true},
    component: () => import("./views/acquisition/landing_pages/new/Wysiwyg.vue"),
  },
  {
    path: '/accounts/:accountId/landing_pages/editor',
    name: "Landing_pages_editor",
    meta: { requiresAuth: true, childRouteWithinFolder: 'landing_page', resetSnackbar: true, implementTimezone: true},
    component: () => import("./views/acquisition/landing_pages/new/Editor.vue"),
  },
  {
    path: '/accounts/:accountId/landing_pages/editor/:pageId/edit',
    name: "Edit_landing_pages_editor",
    meta: { requiresAuth: true, childRouteWithinFolder: 'landing_page', resetSnackbar: true, implementTimezone: true},
    component: () => import("./views/acquisition/landing_pages/new/Editor.vue"),
  },
  {
    path: '/accounts/:accountId/landing_pages/:pageId/edit',
    name: "Edit_landing_pages",
    meta: { requiresAuth: true, childRouteWithinFolder: 'landing_page', resetSnackbar: true},
    component: () => import("./views/pages/Legacy.vue")
  },
  {
    path: '/accounts/:accountId/landing_pages/:pageId',
    name: "View_landing_pages",
    meta: { requiresAuth: true, childRouteWithinFolder: 'landing_page', resetSnackbar: true, implementTimezone: true},
    component:()=> import("./views/acquisition/landing_pages/details/PageDetails.vue")
  },
  {
    path: '/accounts/:accountId/landing_pages/:pageId/preview',
    name: "Preview_landing_pages",
    meta: { requiresAuth: true, childRouteWithinFolder: 'landing_page', layout: "Default", resetSnackbar: true},
    component: () => import("./views/acquisition/landing_pages/details/Preview.vue"),
  },
  {
    path: '/accounts/:accountId/landing_pages',
    name: "Landing_pages",
    meta: { requiresAuth: true, folder_type: 'landing_page', resetSnackbar: true},
    component:()=> import("./views/acquisition/landing_pages/LandingPages.vue"),
  },
  {
    path: "/accounts/:accountId/forms",
    name: "Forms",
    meta: { requiresAuth: true, folder_type: 'signup_form' },
    component: () => import("./views/acquisition/sign_up_forms/SignUpForms.vue")
  },
  {
    path: '/accounts/:accountId/forms/new',
    name: "New_forms",
    meta: { requiresAuth: true, childRouteWithinFolder: 'signup_form'},
    component: () => import("./views/pages/Legacy.vue")
  },
  {
    path: '/accounts/:accountId/forms/:formId/html_code',
    name: "Forms_html_code",
    meta: { requiresAuth: true, childRouteWithinFolder: 'signup_form'},
    component: () => import("./views/pages/Legacy.vue")
  },
  {
    path: '/accounts/:accountId/forms/:formId/edit',
    name: "Edit_forms",
    meta: { requiresAuth: true, childRouteWithinFolder: 'signup_form'},
    component: () => import("./views/pages/Legacy.vue")
  },
  {
    path: '/accounts/:accountId/forms/:formId/view/:viewId',
    name: "Forms_html_code",
    meta: { requiresAuth: true, childRouteWithinFolder: 'signup_form'},
    component: () => import("./views/pages/Legacy.vue")
  },
  {
    path: "/accounts/:accountId/forms/:formId/view/:viewID",
    name: "View_forms",
    meta: { layout: "Default", requiresAuth: true, chat: false },
    component: () => import("./views/pages/Legacy.vue")
  },
  {
    path: "/accounts/:accountId/ctags",
    name: "Campaign_tags",
    meta: { requiresAuth: true, folder_type: "campaign_tag"  },
    component: () => import("./views/campaigns/campaign_tags/CampaignTags.vue")
  },
  {
    path: "/accounts/:accountId/tags",
    name: "contact_tags",
    meta: { requiresAuth: true, folder_type: 'contact_tag'},
    component: () => import("./views/tags/ContactTags.vue")
  },
  {
    path: "/accounts/:accountId/tags/:tagId/contact_tags",
    name: "View_contact_tags_legacy",
    meta: { requiresAuth: true, childRouteWithinFolder: 'contact_tag'},
    component: () => import("./views/pages/Legacy.vue")
  },
  {
    path: "/accounts/:accountId/tags/:tagId",
    name: "View_contact_tags",
    meta: { requiresAuth: true,childRouteWithinFolder: 'contact_tag' },
    component: () => import("./views/tags/TagDetails.vue")
  },
  {
    path: "/accounts/:accountId/relational_tables",
    name: "Relational_tables",
    meta: { requiresAuth: true, folder_type: 'relational_table' },
    component: () => import("./views/relational/tables/RelationalTables.vue")
  },
  {
    path: "/accounts/:accountId/relational_tables/new",
    name: "New_relational_tables",
    meta: { requiresAuth: true, childRouteWithinFolder: "relational_table" },
    component: () => import("./views/relational/tables/NewRelationalTable.vue")
  },
  {
    path: '/accounts/:accountId/relational_tables/:table_id',
    name: "Relational_tables_dashboard",
    meta: { requiresAuth: true, childRouteWithinFolder: 'relational_table' },
    component: () => import('./views/relational/tables/RelationalTablesDashboard.vue'),
  },
  {
    path: '/accounts/:accountId/relational_tables/:table_id/import',
    name: "Import_relational_table",
    meta: { requiresAuth: true, childRouteWithinFolder: 'relational_table' },
    component: () => import('./views/relational/tables/ImportRelationalTable.vue'),
  },
  {
    path: '/accounts/:accountId/relational_tables/:table_id/edit',
    name: "Edit_relational_table",
    meta: { requiresAuth: true, childRouteWithinFolder: 'relational_table' },
    component: () => import("./views/relational/tables/NewRelationalTable.vue")
  },
  {
    path: '/accounts/:accountId/relational_tables/:table_id/duplicate',
    name: "Duplicate_relational_table",
    meta: { requiresAuth: true, childRouteWithinFolder: 'relational_table' },
    component: () => import("./views/relational/tables/NewRelationalTable.vue")
  },
  {
    path: '/accounts/:accountId/relational_queries',
    name: "Relational_queries",
    meta: { requiresAuth: true, folder_type : 'sql_querie' },
    component: () => import("./views/audience/sql_queries/SqlQueries.vue")
  },
  {
    path: "/accounts/:accountId/dynamic_contents",
    name: "Dynamic_contents",
    meta: { requiresAuth: true },
    component: () => import("./views/content/dynamic_content/DynamicContent.vue")
  },
  {
    path: "/accounts/:accountId/dynamic_contents/new",
    name: "New_dynamic_contents",
    meta: { requiresAuth: true },
    component: () => import("./views/content/dynamic_content/CreateDynamicContent.vue")
  },
  {
    path: "/accounts/:accountId/dynamic_contents/:content_id/edit",
    name: "Edit_dynamic_contents",
    meta: { requiresAuth: true },
    component: () => import("./views/content/dynamic_content/EditDynamicContent.vue")
  },
  {
    path: "/accounts/:accountId/footers",
    name: "Footers",
    meta: { requiresAuth: true },
    component: () => import("./views/content/footer_management/FooterManagement.vue")
  },
  {
    path: '/accounts/:accountId/coupon_banks',
    name: "Coupon_banks",
    component: () => import("./views/content/coupon_banks/CouponBanks"),
    meta: { requiresAuth: true, section:'coupon_bank' },
  },
  {
    path: '/accounts/:accountId/coupon_banks/:itemId/coupon_dashboard',
    name: 'Coupon_banks_dashboard',
    component: () => import('./views/content/coupon_banks/CouponBanksDashboard.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: "/accounts/:accountId/social_campaigns",
    name: "Social_campaigns",
    meta: { requiresAuth: true },
    component: () => import("./views/pages/Legacy.vue")
  },
  {
    path: "/accounts/:accountId/social_content_categories",
    name: "Social_content_categories",
    meta: { requiresAuth: true },
    component: () => import("./views/pages/Legacy.vue")
  },
  {
    path: "/accounts/:accountId/mobile_keywords",
    name: "Mobile_keywords",
    meta: { requiresAuth: true,module:'mobile' },
    component: () => import("./views/content/keywords/MobileKeywords.vue")
  },
  {
    path: "/accounts/:accountId/mobile_keywords/:Id",
    name: "Mobile Keywords Dashboard",
    meta: { requiresAuth: true,module:'mobile' },
    component: () => import("./views/content/keywords/MobileKeywordDashboard.vue")
  },
  {
    path: '/accounts/:accountId/mobile_keywords/:keywordId/sms_click',
    name: 'Mobile_keyword_click_report',
    component: () => import('./views/content/keywords/SmsClick.vue'),
    meta: { requiresAuth: true,module:'mobile' },
    children:[
      {
        path: "",
        name: "Mobile_keyword_overview_tab",
        meta: { requiresAuth: true },
        component: () => import("./views/content/keywords/Overview.vue"),        
      },
      {
        path: "detailed",
        name: "Mobile_keyword_detailed_report",
        meta: { requiresAuth: true },
        component: () => import("./views/content/keywords/DetailedReport.vue"),        
      },
    ]
  },
  {
    path: "/accounts/:accountId/keyword_contacts/:contactId",
    name: "Keyword_contact_detail",
    meta: { requiresAuth: true,module:'mobile' },
    component: () => import("./views/content/keywords/KeywordDetails.vue")
  },
  {
    path: '/accounts/:accountId/mobile_keywords/:keywordId/sms_click/:urlId/url_report',
    name: 'Mobile_keyword_click_url_report',
    component: () => import('./views/content/keywords/UrlReport.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: "/accounts/:accountId/custom_fields",
    name: "Custom_fields",
    meta: { requiresAuth: true },
    component: () => import("./views/fields/CustomFields.vue")
  },
  {
    path: "/accounts/:accountId/preference_pages",
    name: "Preference_pages",
    meta: { requiresAuth: true },
    component: () => import("./views/preference_management/PreferenceManagement.vue")
  },{
    path: "/accounts/:accountId/preference_pages/:pageId",
    name: "Preference_pages_details",
    meta: { requiresAuth: true },
    component: () => import("./views/preference_management/details/PageDetails.vue")
  },
  {
    path: "/accounts/:accountId/preference_pages/:pageId/preview",
    name: "Preview_preference_page",
    meta: { requiresAuth: true, layout:'Default' },
    component: () => import("./views/preference_management/details/Preview.vue")
  },
  {
    path: "/accounts/:accountId/preference_pages/dndeditor/create",
    name: "Preference_pages_dnd_editor_create",
    meta: { requiresAuth: true },
    component: () => import("./views/preference_management/new/DnDEditor.vue")
  },
  {
    path: "/accounts/:accountId/preference_pages/dndeditor/:pageId/edit",
    name: "Preference_pages_dnd_editor",
    meta: { requiresAuth: true },
    component: () => import("./views/preference_management/new/DnDEditor.vue")
  },
  {
    path: "/accounts/:accountId/preference_pages/editor/create",
    name: "Preference_pages_editor_page",
    meta: { requiresAuth: true },
    component: () => import("./views/preference_management/new/PreferencePagesEditor.vue")
  },
  {
    path: "/accounts/:accountId/preference_pages/:pageId/edit",
    name: "Preference_pages_editor",
    meta: { requiresAuth: true },
    component: () => import("./views/preference_management/new/PreferencePagesEditor.vue")
  },
  {
    path: "/accounts/:accountId/social_leads",
    name: "Social_leads",
    meta: { requiresAuth: true },
    component: () => import("./views/audience/SocialLeads.vue")
  },
  {
    path: "/accounts/:accountId/social_accounts",
    name: "Social_accounts",
    meta: { requiresAuth: true },
    component: () => import("./views/pages/Legacy.vue")
  },
  {
    path: "/accounts/:accountId/websites",
    name: "Websites",
    meta: { requiresAuth: true },
    component: () => import("./views/audience/web_tracking/WebTracking.vue")
  },
  {
    path: "/accounts/:accountId/websites/websiteId",
    name: "View_websites",
    meta: { requiresAuth: true },
    component: () => import("./views/pages/Legacy.vue")
  },
  {
    path: "/accounts/:accountId/recurring_campaign_report",
    name: "Recurring_campaign_report",
    meta: { requiresAuth: true },
    component: () => import("./views/pages/Legacy.vue")
  },
  {
    path: "/accounts/:accountId/reports",
    name: "Campaign_reports",
    meta: { requiresAuth: true },
    component: () => import("./views/reports/CampaignReports.vue")
  },
  {
    path: "/accounts/:accountId/ab_reports",
    name: "AB_campaign_report",
    meta: { requiresAuth: true },
    component: () => import("./views/reports/ABReports.vue")
  },
  {
    path: "/accounts/:accountId/campaigns/:campaignId/ab_report",
    name: "AB_campaign_dashboard",
    meta: { requiresAuth: true },
    component: () => import("./views/reports/abDashboard/Dashboard.vue")
  },
  {
    path: "/accounts/:accountId/test_reports",
    name: "Test_reports",
    meta: { requiresAuth: true },
    component: () => import("./views/pages/Legacy.vue")
  },
  {
    path: "/accounts/:accountId/campaigns/:campaignId/delivered_report",
    name: "Delivered_report",
    meta: { requiresAuth: true },
    component: () => import("./views/reports/statistics/Delivered.vue")
  },
  {
    path: "/accounts/:accountId/campaigns/:campaignId/open_report",
    name: "Open_report",
    meta: { requiresAuth: true },
    component: () => import("./views/reports/statistics/Open.vue")
  },
  {
    path: "/accounts/:accountId/campaigns/:campaignId/link_report",
    name: "Link_report",
    meta: { requiresAuth: true },
    component: () => import("./views/reports/statistics/Link.vue")
  },
  {
    path: "/accounts/:accountId/campaigns/:campaignId/click_report",
    name: "Click_report",
    meta: { requiresAuth: true },
    component: () => import("./views/reports/statistics/Click.vue")
  },
  {
    path: "/accounts/:accountId/campaigns/:campaignId/bounce_report",
    name: "Bounce_report",
    meta: { requiresAuth: true },
    component: () => import("./views/reports/statistics/Bounce.vue")
  },
  {
    path: "/accounts/:accountId/campaigns/:campaignId/url_report",
    name: "URL_report",
    meta: { requiresAuth: true },
    component: () => import("./views/reports/statistics/Url.vue")
  },
  {
    path: "/accounts/:accountId/contacts/:contactId/resend-campaign/:campaignId",
    name: "Resend_campaign",
    meta: { requiresAuth: true },
    component: () => import("./views/contacts/ResendCampaign.vue")
  },
  {
    path: "/accounts/:accountId/lists/:listId/contacts/:contactId/resend-campaign/:campaignId",
    name: "Resend_campaign",
    meta: { requiresAuth: true },
    component: () => import("./views/contacts/ResendCampaign.vue")
  },
  {
    path: "/accounts/:accountId/ytd_reports",
    name: "Ytd_reports",
    meta: { requiresAuth: true },
    component: () => import("./views/error/Error404.vue")
  },
  {
    path: "/accounts/:accountId/sms_campaigns",
    name: "SMS_campaigns",
    meta: { requiresAuth: true, section:'sms_campaigns',module:'mobile' },
    component: async() => await checkSPlitKey(constants.SPLIT_IO_KEYS.isUIDAccount) ? import("./views/campaigns/sms/UIDSMSCampaigns.vue") :import("./views/campaigns/sms/SMSCampaigns.vue"),
  },
  {
    path: '/accounts/:accountId/sms_campaigns/new',
    name: 'New_SMS_campaign',
    component: () => import('./views/campaigns/sms/new/Stepper.vue'),
    meta: { requiresAuth: true, section: 'sms_campaigns',module:'mobile', implementTimezone: true },
  },
  {
    path: "/accounts/:accountId/sms_campaigns/:campaignId",
    name:"Campaign_sms_dasboard",
    meta: { requiresAuth: true, section: 'sms_campaigns',module:'mobile' },
    component: () => import('./views/campaigns/sms/CampaignDashboard.vue'),
  },
  {
    path: "/accounts/:accountId/sms_campaigns/:campaignId/sms/:type", 
    name:"Campaign_sms",
    meta: { requiresAuth: true, section: 'sms_campaigns',module:'mobile', implementTimezone: true },
    component: () => import('./views/campaigns/sms/CampaignSms.vue'),
  },
  {
    path: '/accounts/:accountId/sms_campaigns/:campaignId/duplicate',
    name: 'Duplicate_SMS_campaign',
    component: () => import('./views/campaigns/sms/new/Stepper.vue'),
    meta: { requiresAuth: true, section: 'sms_campaigns',module:'mobile', implementTimezone: true },
  },
  {
    path: '/accounts/:accountId/sms_campaigns/:campaignId/edit',
    name: 'Edit_SMS_campaign',
    component: () => import('./views/campaigns/sms/new/Stepper.vue'),
    meta: { requiresAuth: true, section: 'sms_campaigns',module:'mobile', implementTimezone:true},
  },
  {
    path: '/accounts/:accountId/sms_campaigns/:campaignId/sms_replies',
    name: 'SMS_campaign_replies',
    component: () => import('./views/campaigns/sms/SmsReplies.vue'),
    meta: { requiresAuth: true, section: 'sms_campaigns' },
  },
  {
    path: '/accounts/:accountId/sms_campaigns/:campaignId/sms_click',
    name: 'SMS_campaign_click_report',
    component: () => import('./views/campaigns/sms/SmsClick.vue'),
    meta: { requiresAuth: true, section: 'sms_campaigns' },
    children:[
      {
        path: "",
        name: "overview_tab",
        meta: { requiresAuth: true },
        component: () => import("./views/campaigns/sms/Overview.vue"),        
      },
      {
        path: "detailed",
        name: "detailed_report",
        meta: { requiresAuth: true },
        component: () => import("./views/campaigns/sms/DetailedReport.vue"),        
      },
    ]
  },
  {
    path: '/accounts/:accountId/sms_campaigns/:campaignId/sms_click/:urlId/url_report',
    name: 'SMS_campaign_click_url_report',
    component: () => import('./views/campaigns/sms/UrlReport.vue'),
    meta: { requiresAuth: true, section: 'sms_campaigns' },
  },
  {
    path: "/accounts/:accountId/push_applications",
    name: 'Push_campaigns',
    meta: { requiresAuth: true, section: 'push_campaigns'},
    component: () => import("./views/pages/Legacy.vue")
  },
  {
    path: "/accounts/:accountId/transactional_campaigns",
    name: 'Transactional_campaigns',
    meta: { requiresAuth: true },
    component: () => import("./views/campaigns/transactional/TransactionalCampaign.vue")
  },
  {
    path: "/accounts/:accountId/transactional_campaigns/new",
    name: 'New_transactional_campaign',
    meta: { requiresAuth: true },
    component: () => import("./views/campaigns/transactional/NewTransactionalCampaign.vue")
  },
  {
    path: "/accounts/:accountId/transactional_campaigns/:campaignId/edit",
    name: "transactional_campaigns_edit",
    meta: { requiresAuth: true },
    component: () => import("./views/campaigns/transactional/NewTransactionalCampaign.vue")
  },
  {
    path: "/accounts/:accountId/transactional_campaigns/:campaignId/duplicate",
    name: "transactional_campaigns_duplicate",
    meta: { requiresAuth: true },
    component: () => import("./views/campaigns/transactional/NewTransactionalCampaign.vue")
  },
  {
    path: "/accounts/:accountId/transactional_sms_campaigns",
    name: 'transactional_sms_campaigns',
    meta: { requiresAuth: true, module:'mobile' },
    component: () => import("./views/campaigns/transactionalSms/TransactionalSmsCampaign.vue")
  },
  {
    path: "/accounts/:accountId/transactional_sms_campaigns/new",
    name: 'New_transactional_sms_campaigns',
    meta: { requiresAuth: true, module:'mobile' },
    component: () => import("./views/campaigns/transactionalSms/NewTransactionalSmsCampaign.vue")
  },
  {
    path: "/accounts/:accountId/transactional_sms_campaigns/:campaignId/edit",
    name: 'transactional_sms_campaigns_edit',
    meta: { requiresAuth: true, module:'mobile' },
    component: () => import("./views/campaigns/transactionalSms/NewTransactionalSmsCampaign.vue")
  },
  {
    path: "/accounts/:accountId/transactional_sms_campaigns/:campaignId/duplicate",
    name: 'transactional_sms_campaigns_duplicate',
    meta: { requiresAuth: true, module:'mobile' },
    component: () => import("./views/campaigns/transactionalSms/NewTransactionalSmsCampaign.vue")
  },
  {
    path: "/accounts/:accountId/social_schedules",
    name: 'Social_schedules',
    meta: { requiresAuth: true },
    component: () => import("./views/pages/Legacy.vue")
  },
  {
    path: "/accounts/:accountId/surveys",
    name: 'Surveys',
    meta: { requiresAuth: true, section:'surveys', implementTimezone: true },
    component: () => import("./views/acquisition/survey/Surveys.vue"),
  },
  {
    path: "/accounts/:accountId/cleansing_rules",
    name: 'Cleansing_rules',
    meta: { requiresAuth: true },
    component: () => import("./views/cleansing_rules/CleansingRules.vue")
  },
  {
    path: "/accounts/:accountId/cleansing_rules/new",
    meta: { requiresAuth: true },
    component: () => import("./views/cleansing_rules/create/Init.vue"),
    children: [
      {
        path: "/accounts/:accountId/cleansing_rules/new",
        name: "Cleansing_non_openers",
        meta: { requiresAuth: true },
        component: () => import("./views/cleansing_rules/create/CleanseNonOpeners.vue"),        
      },
      {
        path: "/accounts/:accountId/cleansing_rules/new/mega",
        name: "Cleansing_mega_openers",
        meta: { requiresAuth: true },
        component: () => import("./views/cleansing_rules/create/CleanseMegaOpeners.vue"),       
      }
    ]
  },
  {
    path: "/accounts/:accountId/cleansing_rules/:id/edit",
    meta: { requiresAuth: true },
    component: () => import("./views/cleansing_rules/create/Init.vue"),
    children: [
      {
        path: "/accounts/:accountId/cleansing_rules/:id/edit",
        name: "Cleansing_non_openers_edit",
        meta: { requiresAuth: true },
        component: () => import("./views/cleansing_rules/create/CleanseNonOpeners.vue"),      
      },
      {
        path: "/accounts/:accountId/cleansing_rules/:id/edit/mega",
        name: "Cleansing_mega_openers_edit",
        meta: { requiresAuth: true },
        component: () => import("./views/cleansing_rules/create/CleanseMegaOpeners.vue"),       
      }
    ]
  },
  {
    path: '/accounts/:accountId/image_groups',
    name: 'Optimize_on_open',
    component: () => import("./views/content/optimize_on_open/OptimizeOnOpen.vue"),
    meta: { requiresAuth: true, folder_type: 'image_group', section:'optimize_on_open'},
  },
  {
    path: "/accounts/:accountId/image_groups/new",
    name: 'Optimize_on_open_create',
    meta: { requiresAuth: true, childRouteWithinFolder : 'image_group', implementTimezone: true },
    component: () => import("./views/content/optimize_on_open/add_edit_image_group/ImageGroup.vue")
  },
  {
    path: "/accounts/:accountId/image_groups/:groupId/edit",
    name: 'Optimize_on_open_edit',
    meta: { requiresAuth: true, childRouteWithinFolder : 'image_group', implementTimezone: true },
    component: () => import("./views/content/optimize_on_open/add_edit_image_group/ImageGroup.vue")
  },
  {
    path: "/accounts/:accountId/image_groups/:groupId",
    name: 'Optimize_on_open_details',
    meta: { requiresAuth: true, childRouteWithinFolder : 'image_group' },
    component: () => import("./views/content/optimize_on_open/group_details/GroupDetails.vue")
  },
  {
    path: '/accounts/:accountId/live_content_images',
    name: 'Live_content_images',
    meta: { requiresAuth: true, folder_type: 'countdown_timer' },
    component: () => import("./views/content/live/CountdownTimer.vue")
  },
  {
    path: '/accounts/:accountId/live_content_images/:contentId/edit',
    name: 'Edit_live_content_images',
    meta: { requiresAuth: true, childRouteWithinFolder: 'countdown_timer' },
    component: () => import("./views/pages/Legacy.vue")
  },
  {
    path: '/accounts/:accountId/live_content_images/new',
    name: 'New_live_content_images',
    meta: { requiresAuth: true, childRouteWithinFolder: 'countdown_timer' },
    component: () => import("./views/pages/Legacy.vue")
  },
  {
    path: '/accounts/:accountId/live_content_images/:contentId/countdown.gif',
    name: 'Edit_live_content_images_countdown',
    meta: { requiresAuth: true, childRouteWithinFolder: 'countdown_timer' },
    component: () => import("./views/pages/Legacy.vue")
  },
  {
    path: "/accounts/:accountId/content_feeds",
    name: "Content_feeds",
    meta: { requiresAuth: true, folder_type: "content_feed" },
    name: 'Content_feeds',
    component: () => import("./views/content/feeds/ContentFeeds.vue")
  },
  {
    path: "/accounts/:accountId/product_recommendations",
    meta: { requiresAuth: true },
    component: () => import("./views/content/recommendations/product/Init.vue"),
    props: true,
    children: [
      {
        path: "",
        name: "Product_catalog",
        meta: { requiresAuth: true },
        component: () => import("./views/content/recommendations/product/Catalog.vue"),        
      },
      {
        path: "product_feeds",
        name: "Product_feeds",
        meta: { requiresAuth: true },
        component: () => import("./views/content/recommendations/product/Feeds.vue"),        
      },
      {
        path: "product_feed_templates",
        name: "Product_feed_templates",
        meta: { requiresAuth: true },
        component: () => import("./views/content/recommendations/product/Templates.vue"),        
      },
    ],
  },
  {
    path: "/accounts/:accountId/product_recommendations/product_feed_templates/new",
    name: "New_feed_template_editor",
    meta: { requiresAuth: true },
    component: () => import("./views/content/recommendations/product/Editor.vue"), 
  },
  {
    path: "/accounts/:accountId/product_recommendations/product_feed_templates/:id",
    name: "Edit_feed_template_editor",
    meta: { requiresAuth: true },
    component: () => import("./views/content/recommendations/product/Editor.vue"), 
  },
  {
    path: "/accounts/:accountId/product_recommendations/file_import",
    name: "Product_catalog_import",
    meta: { requiresAuth: true },
    component: () => import("./views/content/recommendations/product/FileImport.vue")
  },
  {
    path: '/accounts/:accountId/journeys',
    name: 'Journey',
    meta: { requiresAuth: true, chat: false, folder_type: 'journey' },
    component: () => import('./views/automation/journey/Journeys.vue'),
  },
  {
    path: '/accounts/:accountId/journeys/new',
    name: 'New_journey',
    meta: { requiresAuth: true, chat: false, childRouteWithinFolder: 'journey' },
    component:()=> import('./views/automation/journey/new/JourneySelection.vue')
  },
  {
    path: '/accounts/:accountId/journeys/new/scratch',
    name: 'New_Journey_From_Scratch',
    meta: { requiresAuth: true, chat: false, childRouteWithinFolder: 'journey', implementTimezone: true },
    component:()=> import('./views/automation/journey/new/NewJourneyScratch.vue')
  },
  {
    path: '/accounts/:accountId/journeys/new/template',
    name: 'New_Journey_Template',
    meta: { requiresAuth: true, chat: false, childRouteWithinFolder: 'journey', implementTimezone: true },
    component:()=> import('./views/automation/journey/new/Init.vue')
  },
  {
    path: '/accounts/:accountId/journeys/:journeyId/edit',
    name: 'Journey_edit',
    meta: { requiresAuth: true, chat: false, childRouteWithinFolder: 'journey', implementTimezone: true },
    component:()=> import('./views/automation/journey/new/NewJourneyScratch.vue')
  },
  {
      path: '/accounts/:accountId/journeys/:journeyId/builder',
      name: 'Journey_builder',
      meta: { requiresAuth: true, chat: false, childRouteWithinFolder: 'journey'},
      component: () => import('./views/pages/Legacy.vue'),
  },
  {
      path: '/accounts/:accountId/journeys/:journeyId/journey_contacts',
      name: 'Journey_contacts',
      meta: { requiresAuth: true, chat: false, childRouteWithinFolder: 'journey' },
      component: async() => await checkSPlitKey(constants.SPLIT_IO_KEYS.isUIDAccount) ?import('./views/automation/journey/UIDJourneyContacts.vue') :  import('./views/automation/journey/JourneyContacts.vue'),
  },
  {
    path: "/accounts/:accountId/data_journeys",
    name: 'Data_journeys',
    meta: { requiresAuth: true, chat: false, folder_type: 'data_journey', implementTimezone: true },
    component: () => import("./views/automation/data_journey/DataJourneys.vue"),
  },
  {
    path: "/accounts/:accountId/data_journeys/:journeyId/builder",
    name: 'Data_journey_builder',
    meta: { requiresAuth: true, chat: false },
    component: () => import("./views/pages/Legacy.vue")
  },
  {
    path: "/accounts/:accountId/acquisition/builders/:journeyId/get_builder",
    name: 'Data_journey_get_builder',
    meta: { requiresAuth: true, childRouteWithinFolder: 'acquisition_builder', chat: false, search: false, section:'acquisition_builder' },
    component: () => import("./views/pages/Legacy.vue")
  },
  {
    path: "/accounts/:accountId/lists/:listId/contacts/new",
    name: 'New_contacts',
    meta: { requiresAuth: true },
    component: () => import("./views/pages/Legacy.vue")
  },
  {
    path: "/accounts/:accountId/contents/new_email_template",
    name: 'New_email_template',
    meta: { requiresAuth: true, chat: false },
    redirect: "/404"
  },
  {
    path: "/accounts/:accountId/contents/new_email_template/:contentId",
    name: 'New_email_template_with_params',
    meta: { requiresAuth: true, chat: false },
    redirect: "/404"
  },
  {
    path: "/accounts/:accountId/contents/edit_email_template/:contentId",
    name: 'Edit_email_template',
    meta: { requiresAuth: true, chat: false },
    redirect: "/404"
  },
  {
    path: "/accounts/:accountId/contents/:contentId/duplicate_email_template",
    name: 'Duplicate_email_template_error_404',
    component: () => import("./views/error/Error404.vue")
  },
  {
    path: '/accounts/:accountId/contents/:contentId/duplicate_email_content',
    name: 'duplicate_email_content_error_404',
    component: () => import("./views/error/Error404.vue")
  },
  {
    path: '/accounts/:accountId/contents/email_content',
    name: 'Email_content',
    component: () => import("./views/pages/Legacy.vue"),
    meta: { requiresAuth: true, chat: false },
    beforeEnter(to, from, next) {
        if(to.query && to.query['content[editor_type]'] && 
            (parseInt(to.query['content[editor_type]'], 10) === 4 || parseInt(to.query['content[editor_type]'], 10) === 1))
        {
            next('/404');
        }
        next();
    },
  },
  {
    path: "/accounts/:accountId/archive",
    name: "Archive",
    meta: { requiresAuth: true},
    component: () => import("./views/archive/Archive.vue")
  },
  {
    path: "/accounts/:accountId/connections",
    name: 'connections',
    meta: { requiresAuth: true, search: {path: "/campaigns"} },
    component: () => import("./views/pages/Legacy.vue")
  },
  {
    path: "/accounts/:accountId/*",
    name: 'Manage_accounts_legacy',
    meta: { requiresAuth: true },
    component: () => import("./views/pages/Legacy.vue")
  },
  {
    path: "/accounts/:accountId",
    name: 'Manage_accounts_legacy',
    meta: { requiresAuth: true },
    component: () => import("./views/pages/Legacy.vue")
  },
  {
    path: "/external",
    name: 'External',
    meta: { requiresAuth: true },
    component: () => import("./views/pages/Legacy.vue")
  },
  {
    path: "*",
    name: 'Error_404_general',
    redirect: "/404"
  }
];
